import { solanaPubkeyBase58 } from "@stealthos/sdk";
import { BN254_SCALAR_FIELD } from "../../joinsplit-v2/notes";
import type { SolanaNetworkConfig } from "../../config/solana";
import { parsePrivateAddress } from "../../utils/inbox-crypto";
import { solanaRecipientInboxKey } from "../../joinsplit-v2/solana/recipient";

export function solanaPaymentLink(
  search: string,
  network: SolanaNetworkConfig,
) {
  const params = new URLSearchParams(search);
  const recipient = params.get("vault") ?? params.get("to");
  if (recipient === null) return null;
  const address = parsePrivateAddress(recipient.trim());
  let publicSend = false;
  if (!params.has("vault")) {
    try {
      solanaPubkeyBase58(recipient.trim());
      publicSend = true;
    } catch {
      /* Private payment link. */
    }
  }
  const tokenParam = params.get("token");
  const token =
    tokenParam && tokenParam !== "any"
      ? network.tokens.find(
          (candidate) => (candidate.mint ?? "sol") === tokenParam,
        )
      : undefined;
  const error =
    params.has("network") && params.get("network") !== network.key
      ? "This payment link belongs to another network."
      : !publicSend &&
          (!address ||
            BigInt(address.mpkHex) <= 0n ||
            BigInt(address.mpkHex) >= BN254_SCALAR_FIELD ||
            !solanaRecipientInboxKey(address.inboxPublicKeyHex))
        ? "This payment link needs a valid recipient private address and inbox key."
        : tokenParam && tokenParam !== "any" && !token
          ? "This payment link uses an unsupported token."
          : null;
  return {
    mode: publicSend && !error ? ("send" as const) : ("deposit" as const),
    recipient: recipient.trim(),
    amount: params.get("amount") ?? "",
    token,
    error,
  };
}
